import 'bootstrap/dist/css/bootstrap.css';
import BootstrapVue from 'bootstrap-vue';
import Vue from 'vue';
import Vuex from 'vuex';
import VueCookies from 'vue-cookies';
import store from './store';
import App from './App.vue';
import router from './router';
import vuetify from './plugins/vuetify';

Vue.use(Vuex);
Vue.use(BootstrapVue);
Vue.use(VueCookies);
Vue.config.productionTip = false;
Vue.$cookies.config('7d');

new Vue({
  router,
  vuetify,
  render: (h) => h(App),
  store,
}).$mount('#app');
